import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import './matchlist.css';
import Navbar from "./navbar";
import BottomBar from "./BottomBar";

const MatchList = () => {
  const [groupedMatches, setGroupedMatches] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMatches = async () => {
      const res = await axios.get('https://backend.aubattle.com/api/matches');
      const grouped = res.data.reduce((acc, match) => {
        const tag = match.match_tag_name || "Uncategorized";
        if (!acc[tag]) acc[tag] = [];
        acc[tag].push(match);
        return acc;
      }, {});
      setGroupedMatches(grouped);
      console.log("✅ Grouped Matches:", grouped);
    };
    fetchMatches();
  }, []);

  // Get matches by status (from grouped matches)
  const getMatchesByStatus = (status) => {
    const allMatches = Object.values(groupedMatches).flat(); // flatten all arrays
    return allMatches.filter((match) => match.status === status);
  };

  return (
    
    <div className="match-list-container">
      
      <Navbar />

      <h2 className="section-title">Upcoming Battles</h2>
      <div className="matches-grid">
        {getMatchesByStatus('upcoming').map((m) => (
          <div key={m.id} className="match-card">
            <div className="card-header">
              <h3 className="match-title">{m.title}</h3>
              <span className="match-time">{new Date(m.match_time).toLocaleString()}</span>
            </div>

            <div className="card-body">
              <div className="match-detail">
                <span className="detail-label">Entry Fee:</span>
                <span className="detail-value">{m.entry_fee} ₹</span>
              </div>
              <div className="match-detail">
                <span className="detail-label">Kill Reward:</span>
                <span className="detail-value">{m.per_kill_reward} ₹</span>
              </div>
              <div className="match-detail">
                <span className="detail-label">Players:</span>
                <span className="detail-value">{m.max_players}</span>
              </div>
              {m.status === 'ongoing' && (
                <div className="room-info">
                  <span>Room ID: {m.room_id}</span>
                  <span>Password: {m.room_password}</span>
                </div>
              )}
            </div>

            <button
              className="join-button"
              onClick={() => navigate(`/match/${m.id}/slots`)}
            >
              JOIN BATTLE
            </button>
          </div>
        ))}
      </div>

      <h2 className="section-title">Ongoing Battles</h2>
      <div className="matches-grid">
        {getMatchesByStatus('ongoing').map((m) => (
          <div key={m.id} className="match-card ongoing">
            <div className="card-header">
              <h3 className="match-title">{m.title}</h3>
              <span className="status-badge">LIVE</span>
            </div>
            <div className="card-body">
              <div className="room-info">
                <span>Room ID: {m.room_id}</span>
                <span>Password: {m.room_password}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <h2 className="section-title">Completed Battles</h2>
      <div className="matches-grid">
        {getMatchesByStatus('completed').map((m) => (
          <div key={m.id} className="match-card completed">
            <div className="card-header">
              <h3 className="match-title">{m.title}</h3>
              <span className="status-badge">ENDED</span>
            </div>
            <div className="card-body">
              <p className="completed-message">Battle completed</p>
            </div>
          </div>
        ))}
      </div>

      <BottomBar />
    </div>
  );
};

export default MatchList;
